export default __webpack_public_path__ + "static/media/heart-small.716d0624.svg";